import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { MiniNavbarComponent } from "./mini-navbar/mini-navbar.component";
import { MainNavbarComponent } from "./main-navbar/main-navbar.component";
import { ContentAreaComponent } from "./content-area/content-area.component";
import { FooterComponent } from "./footer/footer.component";
import { HomePageComponent } from "./content-area/home-page/home-page.component";
import { ResidentialComponent } from "./content-area/residential/residential.component";
import { CommercialComponent } from "./content-area/commercial/commercial.component";
import { OurCompanyComponent } from "./content-area/our-company/our-company.component";
import { ContactComponent } from "./content-area/contact/contact.component";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { OurTeamComponent } from "./content-area/our-team/our-team.component";
import { UserItemComponent } from "./reusable-components/user-item/user-item.component";
import { RouterModule } from "@angular/router";
import { AppRoutingModule } from "./app-routing.module";
import { AgentProfilePageComponent } from "./content-area/agent-profile-page/agent-profile-page.component";
import { LocationsPageComponent } from "./content-area/locations-page/locations-page.component";
import { LocationStateItemComponent } from "./reusable-components/location-state-item/location-state-item.component";
import { MlsListingsAgentPageComponent } from "./reusable-components/mls-listings-agent-page/mls-listings-agent-page.component";
import { AgentListingItemComponent } from "./reusable-components/agent-listing-item/agent-listing-item.component";
import { StrideListingsComponent } from "./reusable-components/stride-listings/stride-listings.component";
import { AllListingsComponent } from "./content-area/all-listings/all-listings.component";
import { IndividualListingComponent } from "./content-area/individual-listing/individual-listing.component";
import { IndividualCommercialComponent } from "./content-area/individual-commercial/individual-commercial.component";
import { IvyGalleryModule } from "angular-gallery";
import { AgmCoreModule } from "@agm/core";
import { GooglePlaceModule } from "ngx-google-places-autocomplete";
import { SearchResultsComponent } from "./content-area/search-results/search-results.component";
import { BlogPageComponent } from "./content-area/blog-page/blog-page.component";
import { BlogItemComponent } from "./reusable-components/blog-item/blog-item.component";
import { PrivacyPolicyComponent } from "./content-area/privacy-policy/privacy-policy.component";

@NgModule({
  declarations: [
    AppComponent,
    MiniNavbarComponent,
    MainNavbarComponent,
    ContentAreaComponent,
    FooterComponent,
    HomePageComponent,
    ResidentialComponent,
    CommercialComponent,
    OurCompanyComponent,
    ContactComponent,
    OurTeamComponent,
    UserItemComponent,
    AgentProfilePageComponent,
    LocationsPageComponent,
    LocationStateItemComponent,
    MlsListingsAgentPageComponent,
    AgentListingItemComponent,
    StrideListingsComponent,
    AllListingsComponent,
    IndividualListingComponent,
    IndividualCommercialComponent,
    SearchResultsComponent,
    BlogPageComponent,
    BlogItemComponent,
    PrivacyPolicyComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    RouterModule,
    IvyGalleryModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyBEal0Z5yofNg6cV0I50YdjKCspE5TZEsQ",
    }),
    GooglePlaceModule,
  ],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
